'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = {
  marginBottom: 6
};
var sizes = {
  xs: {
    fontSize: 'xs'
  },
  sm: {
    fontSize: 'sm'
  },
  md: {},
  lg: {
    fontSize: 'lg'
  }
};
var defaultProps = {
  size: 'md'
};
var Text = {
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = Text;